import { Bt } from './styles';

import React from 'react';

const Button = ({ children, ...props }) => {
  return <Bt {...props}>{children}</Bt>;
};

export default Button;
